import PolimClient from '../utils/api/PolimClient'

export default class CashRequestService {
    static getCashList(page, size, cb) {
        PolimClient.request(
            {
                endpoint: `${process.env.REACT_APP_M2}/api/sarah/tasks/created?offset=${page}&limit=${size}`,
                method: 'GET',
                headers: {
                    'X-Realm': 'M1',
                },
            },
            cb
        )
    }

    static getCashListHeader(page, size, cb) {
        PolimClient.request(
            {
                endpoint: `${process.env.REACT_APP_M2}/api/sarah/tasks/created?offset=${page}&limit=${size}`,
                method: 'HEAD',
                headers: {
                    'X-Realm': 'M1',
                },
            },
            cb
        )
    }
    static createCashRequest(body, cb) {
        PolimClient.request(
            {
                endpoint: `${process.env.REACT_APP_M2}/api/sarah/tasks`,
                method: 'POST',
                body: body,
                headers: {
                    'X-Realm': 'M1',
                },
            },
            cb
        )
    }

    static cancelCashRequest(id, cb) {
        PolimClient.request(
            {
                endpoint: `${process.env.REACT_APP_M2}/api/sarah/tasks/${id}/cancel`,
                method: 'POST',
                body: {},
                headers: {
                    'X-Realm': 'M1',
                },
            },
            cb
        )
    }
}
